import { get } from "lodash";
import {
  takeLatest,
  call,
  all,
  put,
  cancel,
  takeEvery
} from "redux-saga/effects";

import { OPERATIONS } from "../../constants/operations.js";
import { AT_TYPES } from "../../constants/entity.js";
import {
  CORE,
  PROVIDERS,
  SERVICES,
  REGIONS,
  IMAGES,
  ZONES,
  SIZES,
  TIMEZONES
} from "../actions/actionConstants.js";

import { createAction } from "../actions/actionUtils.js";
import { operationAction } from "../reducers/operations/operationActions.js";

import { accountSaga } from "./accountSagas.js";
import { selectEndpointByTypeSaga } from "./endpointSagas.js";
import { operationSaga } from "./operationSagas.js";

// -- CORE DATA -- //

export function* createCoreAction(actionEntity, entityType, options) {
  return operationAction(
    actionEntity,
    yield call(selectEndpointByTypeSaga, entityType),
    OPERATIONS.LIST,
    { pagination: false },
    {
      logActivity: false, // core is reloaded on refresh so don't want it to trigger a lastActivity update
      ...options
    }
  );
}

function* coreDataSaga(action) {
  // console.log("coreDataSaga", action);
  try {
    yield call(
      operationSaga,
      yield createCoreAction(TIMEZONES, AT_TYPES.TIMEZONE),
      true
    );

    yield accountSaga({ logActivity: false }, action);

    yield all([
      call(
        operationSaga,
        yield createCoreAction(SERVICES, AT_TYPES.SERVICE),
        true
      ),
      call(
        operationSaga,
        yield createCoreAction(PROVIDERS, AT_TYPES.PROVIDER),
        true
      ),
      call(
        operationSaga,
        yield createCoreAction(REGIONS, AT_TYPES.REGION),
        true
      ),
      call(operationSaga, yield createCoreAction(ZONES, AT_TYPES.ZONE), true)
    ]);

    yield refreshAllOfCoreDataSaga(action);

    yield put(createAction(CORE.GET_COMPLETE));
  } catch (error) {
    yield cancel();
  }
}

// refresh all variable core stores
function* coreDataByPartsSaga(action, parts, refreshAccount) {
  // console.log("coreDataByPartsSaga ::", action, parts, refreshAccount);

  try {
    const sagaArray = [];

    for (let i = 0; i < parts.length; i++) {
      const element = parts[i];
      sagaArray.push(
        call(
          operationSaga,
          yield createCoreAction(element.actionEntity, element.atType),
          true
        )
      );
    }

    if (refreshAccount) {
      sagaArray.push(call(accountSaga, { logActivity: false }, action));
    }

    yield all(sagaArray);
  } catch (error) {
    yield cancel();
  }
}

function* refreshAllOfCoreDataSaga(action) {
  // console.log("refreshAllOfCoreDataSaga", action);
  const refreshAccount = get(action, "payload;.refreshAccount", false);

  const parts = [
    { actionEntity: IMAGES, atType: AT_TYPES.IMAGE },
    { actionEntity: SIZES, atType: AT_TYPES.SIZE }
  ];

  try {
    yield coreDataByPartsSaga(action, parts, refreshAccount);
  } catch (error) {
    yield cancel();
  }
}

function* refreshPartsOfCoreDataSaga(action) {
  // console.log("refreshPartOfCoreDataSaga", action);
  const { parts, refreshAccount } = action.payload;

  try {
    yield coreDataByPartsSaga(action, parts, refreshAccount);
  } catch (error) {
    yield cancel();
  }
}

// -- WATCHERS -- //

export function* watchCoreDataSagas() {
  yield takeLatest(CORE.GET, coreDataSaga);
  yield takeEvery(CORE.FULL_REFRESH, refreshAllOfCoreDataSaga);
  yield takeEvery(CORE.PART_REFRESH, refreshPartsOfCoreDataSaga);
}
